// extracted by mini-css-extract-plugin
export var deliveryRow = "_sc-a";
export var fixedHeight = "_sc-4";
export var freightLogo = "_sc-9";
export var fullWidth = "_sc-3";
export var priceColumn = "_sc-5";
export var radioSelected = "_sc-7";
export var radioUnselected = "_sc-6";
export var selectedOption = "_sc-2";
export var selectedOptionContainer = "_sc-1";
export var selection = "_sc-0";
export var tallSkeletonText = "_sc-8";